import { getDaysInMonth, getMonth } from 'date-fns';
import { MonthIndexes } from '../constants/date';

const HOURS_IN_DAY = 24;

export const getMonthName = (intl, date, type = 'long') => {
  return intl.formatDate(date, { month: type });
};

/**
 * @param {number} quarterIndex Quarter index, starts with 0
 * @returns {number[]} Month indexes in quartal, Jan=0
 */
export const getQuarterMonthIndexes = (quarterIndex) => {
  switch (quarterIndex) {
    case 0:
      return [0, 1, 2];
    case 1:
      return [3, 4, 5];
    case 2:
      return [6, 7, 8];
    case 3:
    default:
      return [9, 10, 11];
  }
};

export const getHoursInMonthCzechTimeZone = (year, month) => {
  const date = new Date(year, month, 1);
  const daysInMonth = getDaysInMonth(date);
  let hours = daysInMonth * HOURS_IN_DAY;
  /**
   * Date-fns always works in local timezone and returns date. As such,
   * it cannot be forced to use daylight timezone from Czech republic
   * in US locale browser. Therefore we cannot use startOfMonth and difference in
   * hours, but rather do the Daylight saving manually in March and October when
   * time changes;
   */
  if (getMonth(date) === MonthIndexes.MARCH) {
    hours -= 1;
  }
  if (getMonth(date) === MonthIndexes.OCTOBER) {
    hours += 1;
  }
  return hours;
};
